//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AcuvueBonusesTableMobile from "~/components/acuvue-page/AcuvueBonusesTableMobile.vue";
const novichok = 'Новичок';
const opitniy = 'Опытный пользователь';
export default {
  name: 'AcuvueBonusesTable',
  components: {
    AcuvueBonusesTableMobile
  },
  data() {
    return {
      newUserName: novichok,
      expertUserName: opitniy,

      activeUserForMobile: '',
      tableData: [
        {
          rowName: 'Баллы',
          grades: [
            {
              title: novichok,
              values: [
                {
                  title: 'Опрос после подбора',
                  value: '100'
                },
                {
                  title: 'Заполнение профиля в приложении',
                  value: '150'
                },
                {
                  title: 'Прохождение контрольного осмотра',
                  value: '300'
                },
                {
                  title: 'Прохождение 3 шагов',
                  value: '1000'
                }
              ]
            },
            {
              title: opitniy,
              values: [
                {
                  title: 'Опрос после подбора',
                  value: '100'
                },
                {
                  title: 'Заполнение профиля в приложении',
                  value: '150'
                },
                {
                  title: 'Прохождение 3 шагов',
                  value: '1000'
                }
              ]
            }
          ]
        },
        {
          rowName: '',
          grades: [
            {
              title: novichok,
              values: [
                {
                  title: 'Итого',
                  value: '1550'
                },
              ]
            },
            {
              title: opitniy,
              values: [
                {
                  title: 'Итого',
                  value: '1250'
                },
              ]
            }
          ]
        },
        {
          rowName: 'Купоны',
          grades: [
            {
              title: novichok,
              values: [
                {
                  title: 'Первая приветственная скидка',
                  value: '300'
                },
                {
                  title: 'Вторая приветственная скидка',
                  value: '300'
                },
              ]
            },
            {
              title: opitniy,
              values: [
                {
                  title: 'Первая приветственная скидка',
                  value: '300'
                },
                {
                  title: 'Вторая приветственная скидка',
                  value: '300'
                },
                {
                  title: 'Купон на раствор',
                  value: '300'
                },
              ]
            },
          ]
        },
        {
          rowName: '',
          grades: [
            {
              title: novichok,
              values: [
                {
                  title: 'Итого',
                  value: '600'
                },
              ]
            },
            {
              title: opitniy,
              values: [
                {
                  title: 'Итого',
                  value: '900'
                },
              ]
            }
          ]
        },
        {
          rowName: 'Дополнительно',
          grades: [
            {
              title: novichok,
              values: [
                {
                  title: 'Подарок на день рождения',
                  value: '300'
                },
                {
                  title: 'Приглашение друга',
                  value: '1000'
                },
              ]
            },
            {
              title: opitniy,
              values: [
                {
                  title: 'Подарок на день рождения',
                  value: '300'
                },
                {
                  title: 'Приглашение друга',
                  value: '1000'
                },
              ]
            },
          ]
        },
        {
          rowName: '',
          grades: [
            {
              title: novichok,
              values: [
                {
                  title: 'Всего',
                  value: '3450'
                },
              ]
            },
            {
              title: opitniy,
              values: [
                {
                  title: 'Всего',
                  value: '3450'
                },
              ]
            }
          ]
        },
      ]
    }
  },
}
